import React, { FC, useState, useRef } from 'react';

interface Props {
  parentSize: number;
  size: number;
  children: React.ReactNode;
  resizeHandler?: (newSize: number, sectionIdx?: number, fieldIdx?: number) => void;
  updateRights?: boolean;
}

export const getNewSize = function (newWidth: number, parentSize: number): number {
  let columnWidth = Math.ceil((newWidth / parentSize) * 12);
  columnWidth = columnWidth > 12 ? 12 : columnWidth;
  columnWidth = columnWidth <= 1 ? 1 : columnWidth;
  return columnWidth;
};

const Resizable: FC<Props> = ({ parentSize, size, children, resizeHandler, updateRights }: Props) => {
  const [colSize, setColSize] = useState(size);
  const colRef = useRef<HTMLDivElement>(null);
  let x = 0;
  let width = 0;
  let newWidth = 0;

  const mouseMove = function (event) {
    newWidth = width - (x - event.clientX);

    const newSize = getNewSize(newWidth, parentSize);

    if (newSize != colSize) {
      setColSize(newSize);
      resizeHandler && resizeHandler(newSize);
    }
  };

  const mouseUp = function () {
    document.removeEventListener('mousemove', mouseMove);
    document.removeEventListener('mouseup', mouseUp);
  };

  const dragStart = (event) => {
    if (colRef.current) {
      x = event.clientX;
      width = colRef.current.offsetWidth;
      document.addEventListener('mousemove', mouseMove);
      document.addEventListener('mouseup', mouseUp);
    }
  };

  return (
    <>
      <div className="resizable" ref={colRef}>
        {children}
        {updateRights && (
          <span onMouseDown={dragStart} className="resizable-handle mdi mdi-drag-vertical-variant"></span>
        )}
      </div>
    </>
  );
};

export default Resizable;
